import { defineAsyncComponent } from 'vue'

const WebConnexIntegrationPage = () => import('@/pages/integrations/webconnex/WebConnexIntegrationPage.vue')
// App.vue renders meta.layout directly, so it needs an async component wrapper.
const BackendPages = defineAsyncComponent(() => import('@/layouts/BackendPages.vue'))
const WebConnexIntegrationSuccessPage = () => import('@/pages/integrations/webconnex/WebConnexIntegrationSuccessPage.vue')

export default [
  { path: '/integrations/webconnex/supporter', name: 'WebConnexIntegration', component: WebConnexIntegrationPage, meta: { requiresAuth: true, layout: BackendPages } },
  // the user arrives here after a successful OAUTH2 flow integration setup on webconnex side, after we got the apikey and shoved it into our system
  { path: '/integrations/webconnex/success', name: 'WebConnexIntegrationSuccess', component: WebConnexIntegrationSuccessPage, meta: { requiresAuth: true, layout: BackendPages } },
]


